import React, { Component } from 'react';
import './App.css';
import Header from './components/Header';
import Form from './components/Form'
import Recipes from './components/Recipes';
import Footer from './components/Footer';


const key = "b3979b326af181e2a6ff80ad08da717a";
const proxy = "https://cors-anywhere.herokuapp.com/";


class App extends Component {
  state = { 
    recipes: [],
    isBtnClicked: false,
    error: false,
    noResults: ''
  }

  clearLocalStorage = () => {
    localStorage.removeItem("recipes");
    this.setState({recipes: null});
  }

  getRecipe = async (inputValue) => {

    if(inputValue) {
      this.clearLocalStorage();
      this.setState({noResults: ''});
      this.setState({error: false});
      
      try {

        this.setState({isBtnClicked: true});
        const res = await fetch(`${proxy}https://www.food2fork.com/api/search?key=${key}&q=${inputValue}`);
        const data = await res.json();
        this.setState({recipes: data.recipes});
        if(this.state.recipes.length === 0) {

          this.setState({noResults: `Sorry, we couldn't find any results matching "${inputValue}"`})
        }
        
        console.log(this.state.recipes)
      } catch (error) {
        this.setState({error: true});
      }
    }

  };

  componentDidMount = () => {
    const recipes = JSON.parse(localStorage.getItem("recipes"));
    this.setState({recipes});
  };

  componentDidUpdate = () => {
    const recipes = JSON.stringify(this.state.recipes);
    localStorage.setItem("recipes", recipes);
  };

  render() {
    return (
      <div className="app">
          <Header />
          <Form getRecipe={this.getRecipe}/>
          {
            (this.state.isBtnClicked && !this.state.recipes && !this.state.error) && <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          }
          {
            this.state.error && 
            <div className="alert alert-danger text-center" role="alert">
                Oops, something went wrong...Try agin.
            </div>
          }

          {
            this.state.noResults && 
            <div className="alert alert-danger text-center" role="alert">
                {this.state.noResults}
            </div>
          }
          <Recipes recipes={this.state.recipes} />
          <Footer />
      </div>
    );
  }
}

export default App;
